import { render } from "./PostImportInsights.vue?vue&type=template&id=7b2ca010&ts=true"
import script from "./PostImportInsights.vue?vue&type=script&lang=ts"
export * from "./PostImportInsights.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__